/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import type { ThemeType } from "../../../../../global/emotion";
import {
  colors,
  constantSemanticColors,
  fontSizes,
  fontWeights,
  lineHeights,
  radius,
  spacing,
  stroke,
} from "../../../../../global/emotion";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";
import { ListItem } from "../ListItem/ListItem.emotion";
export type OrderedListItemProps = HallowElementProps<"li">;

const itemStyle: Interpolation<ThemeType> = (theme) => ({
  borderTopColor: theme.semanticColors.neutralsLowest,
  borderTopStyle: "solid",
  borderTopWidth: stroke.regular,
  paddingBlock: spacing.l,
  paddingLeft: spacing.l,
  paddingRight: spacing.none,
  position: "relative",
  width: spacing.full,
  zIndex: 0,
  ":last-of-type": {
    borderBottomColor: theme.semanticColors.neutralsLowest,
    borderBottomStyle: "solid",
    borderBottomWidth: stroke.regular,
  },
  "::marker": {
    content: "",
  },
  "::before": {
    background: colors.blackOLED,
    borderRadius: radius.full,
    color: constantSemanticColors.onColorHighest,
    display: "flex",
    fontFeatureSettings: "tnum",
    fontSize: fontSizes.titleS,
    fontVariantNumeric: "tabular-nums",
    fontWeight: fontWeights.titleS,
    height: spacing.xl,
    left: `calc(${spacing.l} + (0.5ch))`,
    lineHeight: lineHeights.titleS,
    placeContent: "center",
    placeItems: "center",
    position: "absolute",
    top: `calc(${spacing.l} + (${lineHeights.titleS} / 2))`,
    transform: "translate(-50%, -50%)",
    width: spacing.xl,
  },
});
const textStyle: Interpolation = {
  display: "inline-block",
  marginLeft: spacing.xl,
  verticalAlign: "text-top",
  width: `calc(${spacing.full} - ${spacing.xl})`,
};

export const OrderedListItem = ({
  children,
  ...props
}: OrderedListItemProps) => {
  return (
    <ListItem css={itemStyle} {...props}>
      <span css={textStyle}>{children}</span>
    </ListItem>
  );
};
